import { getIsAna2 } from '../utils/Ana2';
import { PLAN_OPTION_CHARGE_KIND } from '../constants';

export const usePrice = (people, selectedOutboundFlight, selectedInboundFlight, plans = [], selectedOutboundDate, planOptions = [], useSessionFlag = false, sortedPlanOptionKind = []) => {
  const adult = people ? people.adult || 2 : 2;
  const childrenA = people ? people.childrenA || 0 : 0;
  const childrenB = people ? people.childrenB || 0 : 0;
  const childrenC = people ? people.childrenC || 0 : 0;
  const children2 = people ? people.children2 || 0 : 0;
  const infant = people ? people.infant || 0 : 0;

  let totalAdultPrice = 0;
  let totalChildrenAPrice = 0;
  let totalChildrenBPrice = 0;
  let totalChildrenCPrice = 0;
  let totalChildren2Price = 0;
  let totalInfantPrice = 0;
  let planTotalAmount = 0;
  let planTotalAmountPerPerson = 0;

  plans.forEach((p) => {
    const { adultPrice, childrenAPrice, childrenBPrice, childrenCPrice, children2Price, infantPrice, totalAmount, totalAmountPerPerson } = p;
    totalAdultPrice += Number(adultPrice) || 0;
    totalChildrenAPrice += Number(childrenAPrice) || 0;
    totalChildrenBPrice += Number(childrenBPrice) || 0;
    totalChildrenCPrice += Number(childrenCPrice) || 0;
    // null のまま加算すると 2歳児の宿料金が落ちるため 0 に正規化
    totalChildren2Price += Number(children2Price) || 0;
    totalInfantPrice += Number(infantPrice) || 0;
    planTotalAmount += Number(totalAmount) || 0;
    planTotalAmountPerPerson += Number(totalAmountPerPerson) || 0;
  });

  const priceOutbound = selectedOutboundFlight ? selectedOutboundFlight.price : 0;
  const childPriceOutbound = selectedOutboundFlight ? selectedOutboundFlight.childPrice : 0;
  const priceInbound = selectedInboundFlight ? selectedInboundFlight.price : 0;
  const childPriceInbound = selectedInboundFlight ? selectedInboundFlight.childPrice : 0;

  const adultPriceFlight = priceOutbound + priceInbound;
  const childPriceFlight = childPriceOutbound + childPriceInbound;

  const pricePerAdult = planTotalAmountPerPerson + adultPriceFlight; // 大人１名あたりの料金（検索TOPなどに表示するためのもの）
  const adultPrice = totalAdultPrice + adultPriceFlight;
  const CAPrice = totalChildrenAPrice + childPriceFlight;
  const CBPrice = totalChildrenBPrice + childPriceFlight;
  const CCPrice = totalChildrenCPrice + childPriceFlight;
  const IFPrice = totalInfantPrice + 0; //幼児はフライト料金が0円

  //ANA2の場合は2歳児席ありなのでフライト料金が発生する
  const isAna2 = selectedOutboundFlight ? getIsAna2(selectedOutboundFlight.airline, selectedOutboundDate) : false;
  const child2PriceFlight = isAna2 ? childPriceFlight : 0;
  const C2Price = totalChildren2Price + child2PriceFlight;

  const flightTotalPrice =
    adultPriceFlight * adult + childPriceFlight * childrenA + childPriceFlight * childrenB + childPriceFlight * childrenC + childPriceFlight * children2;
  const totalPrice = planTotalAmount + flightTotalPrice;

  let peoplePrice = [];

  if(people){
    for(let i=0; i<people.adult; i++){
      peoplePrice.push({
        type: 'ADULT',
        kindName: 'おとな',
        flightAndPlan: '座席あり/寝具あり',
        price: adultPrice,
        optionName: [],
      });
    }
    for(let i=0; i<people.childrenA; i++){
      peoplePrice.push({
        type: 'CHILDRENA',
        kindName: 'こども(6〜11歳)',
        flightAndPlan: '座席あり/寝具あり',
        price: CAPrice,
        optionName: [],
      });
    }
    for(let i=0; i<people.childrenB; i++){ 
      peoplePrice.push({
        type: 'CHILDRENB',
        kindName: 'こども(3〜5歳)',
        flightAndPlan: '座席あり/寝具あり',
        price: CBPrice,
        optionName: [],
      });
    }
    for(let i=0; i<people.childrenC; i++){
      peoplePrice.push({
        type: 'CHILDRENC',
        kindName: 'こども(3〜5歳)',
        flightAndPlan: '座席あり/寝具なし',
        price: CCPrice,
        optionName: [],
      });
    }
    for(let i=0; i<people.children2; i++){
      peoplePrice.push({
        type: isAna2 ? 'CHILDRENC' : 'INFANT',
        kindName: 'こども(2歳)',
        flightAndPlan: isAna2 ? '座席あり/寝具なし' : '座席なし/寝具なし',
        price: C2Price,
        optionName: [],
      });
    }
    for(let i=0; i<people.infant; i++){
      peoplePrice.push({
        type: 'INFANT',
        kindName: 'こども(0〜1歳)',
        flightAndPlan: '座席なし/寝具なし',
        price: IFPrice,
        optionName: [],
      });
    }
  }

  // 着地素材がある場合
  if(planOptions && planOptions.length > 0){
    planOptions.map((option, index) => {
      const isGroup = !useSessionFlag ? option.goods.goodsDetailInfo.useUnit === 'group' : option.useUnit === 'group';
      const thisOptionKind = sortedPlanOptionKind && sortedPlanOptionKind[index] ? sortedPlanOptionKind[index] : [];
      const { peopleCounts = {} } = option;
      const { chargeKinds = [] } = option;
      const categoryDetail = !useSessionFlag ? option.goods.goodsDetailInfo.categoryDetail : option.categoryDetail;

      let n = 0;
      if(!useSessionFlag){
        PLAN_OPTION_CHARGE_KIND.forEach((value) => {

          // 台組の場合は代表者にのみ
          if(isGroup){
            if(value.id === 'AD'){
              peoplePrice[n].optionName.push(`${categoryDetail}`);
              peoplePrice[n].price = Number(peoplePrice[n].price) + Number(getPrice(option, value.id, useSessionFlag));
            }

          // 人員単位の場合は選択した分だけ追加
          }else{
            const filteredChargesKinds = chargeKinds && Array.isArray(chargeKinds) ? chargeKinds.filter((chargeKind) => chargeKind.chargeKind === value.id) : [];
            const kindNumber = !useSessionFlag ? peopleCounts[value.id] : filteredChargesKinds.length;

            for(let i=0; i<kindNumber; i++){
              peoplePrice[n].optionName.push(`${categoryDetail}（${value.name}）`);
              peoplePrice[n].price = Number(peoplePrice[n].price) + Number(getPrice(option, value.id, useSessionFlag));
              n++;
            }
          }
        });
      }else{
        thisOptionKind.map((kind) => {
          peoplePrice[n].optionName.push(`${categoryDetail}（${PLAN_OPTION_CHARGE_KIND.find((k) => k.id === kind.chargeKind).name}）`);
          peoplePrice[n].price = Number(peoplePrice[n].price) + Number(getPrice(option, kind.chargeKind, useSessionFlag));
          n++;
        });
      }
    });
    
  }

  const totalPriceIncludePlanOption = peoplePrice.reduce((acc, curr) => acc + curr.price, 0);
  return { totalPrice, totalPriceIncludePlanOption, pricePerAdult, ADPrice: adultPrice, CAPrice, CBPrice, CCPrice, IFPrice, flightTotalPrice, peoplePrice };
};

// chargesListからkind(AD,SNなどの人員種別）のpriceを取得
function getPrice(option, kind, useSessionFlag){
  if(!useSessionFlag){
    const { chargesList } = option.peopleCounts;
    const charge = chargesList.find((charge) => charge.kind === kind);
    return charge ? charge.price : null;
  }else{
    const key = `${kind}Price`;
    return option[key] ? option[key] : null;
  }
}
